function setupWcpReveal() {
  const revealItems = Array.from(document.querySelectorAll('[data-wcp-reveal]'));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!revealItems.length) return;

  const showItem = (item) => item.classList.add('is-visible');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach(showItem);
    return;
  }

  document.documentElement.classList.add('wcp-reveal-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        showItem(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px 18% 0px', threshold: 0.01 }
  );

  revealItems.forEach((item) => observer.observe(item));

  const revealNearViewport = () => {
    revealItems.forEach((item) => {
      if (item.classList.contains('is-visible')) return;
      const rect = item.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.12 && rect.bottom > -80) {
        showItem(item);
        observer.unobserve(item);
      }
    });
  };

  requestAnimationFrame(revealNearViewport);
  window.addEventListener('scroll', revealNearViewport, { passive: true });
  window.addEventListener('resize', revealNearViewport);
}

function setupWcpAnalytics() {
  const main = document.querySelector('#MainContent');
  if (!main || main.dataset.wcpAnalyticsReady === 'true') return;
  main.dataset.wcpAnalyticsReady = 'true';

  const slug = (value = '') =>
    value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 80);

  const pageContext = () => {
    const parts = window.location.pathname.split('/').filter(Boolean);
    return {
      page_type: main.dataset.template || 'unknown',
      resource_handle: parts.at(-1) || 'home',
    };
  };

  const sectionId = (element) =>
    element.closest('.shopify-section[id]')?.id?.replace(/^shopify-section-/, '') || 'unknown';

  const destination = (link) => {
    try {
      const url = new URL(link.href, window.location.origin);
      return `${url.pathname}${url.hash}`.slice(0, 160);
    } catch {
      return 'unknown';
    }
  };

  const publish = (name, payload) => {
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      const result = window.Shopify.analytics.publish(name, payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch {
      // Analytics must never interrupt storefront interactions.
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const label = link.textContent?.trim() || link.getAttribute('aria-label') || 'link';
    const payload = {
      ...pageContext(),
      section_id: sectionId(link),
      link_destination: destination(link),
      label_slug: slug(label),
    };

    if (/commercial account application/i.test(label)) {
      publish('wavecraft:commercial_application_clicked', payload);
    } else if (link.hash.startsWith('#faq-')) {
      publish('wavecraft:faq_topic_selected', payload);
    } else if (link.closest('.wcp-modern-hero')) {
      publish('wavecraft:hero_cta_clicked', payload);
    } else if (link.closest('.wcp-category-runway')) {
      publish('wavecraft:category_route_clicked', payload);
    } else if (
      main.dataset.template?.startsWith('product') &&
      /our-tubes|size-care|safety|contact/.test(link.href)
    ) {
      publish('wavecraft:product_guidance_clicked', payload);
    } else if (
      main.dataset.template?.startsWith('page.contact') &&
      link.closest('.wcp-conversion-strip')
    ) {
      publish('wavecraft:contact_intent_selected', payload);
    }
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const item = event.target;
      if (!(item instanceof HTMLDetailsElement) || !item.open || !item.matches('.wcp-faq-item')) return;
      const question = item.querySelector('summary')?.textContent || 'question';
      publish('wavecraft:faq_question_opened', {
        ...pageContext(),
        section_id: sectionId(item),
        question_slug: slug(question),
      });
    },
    true
  );

  document.addEventListener('submit', (event) => {
    const requestForm = event.target.closest('.wcp-request-form__form');
    if (!requestForm || !requestForm.checkValidity()) return;

    const formType =
      requestForm.querySelector('input[name="contact[Form type]"]')?.value || 'request';

    publish('wavecraft:request_form_submitted', {
      ...pageContext(),
      section_id: sectionId(requestForm),
      form_type: slug(formType),
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      setupWcpReveal();
      setupWcpAnalytics();
    },
    { once: true }
  );
} else {
  setupWcpReveal();
  setupWcpAnalytics();
}
